import { gql } from '@apollo/client';

export const QUERYV2 = gql`
  mutation CancelDowngradeV2ByToken($token: String!, $payload: AutoFilledCancelDowngradePayloadV2) {
    cancelDowngradeV2ByToken(token: $token, payload: $payload) {
      downgradeToProduct
      downgradeToPrice
      startDate
      endDate
      cancelDate
      frequency
      status
      paymentRetryCount
      paymentReminderEndDate
      has3dsVerification
      reminder3dsEndDate
      billingCycleCount
      nextActionUrl
      amountDue
      lastPaymentDate
      nextPaymentAttemptDate
      terminateDate
      isCancelling
      cancelReason
      planRelationId
      _id
      createdAt
      updatedAt
      incompleteBillingDetails
      nextBillingDate
      renewalReminderDate
    }
  }
`;
